import { api } from "./apiSlice";
import type { FormData as DonationFormData } from "@/types/blood-donation";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export type SubmitDonationFormInput = Omit<DonationFormData, "id" | "dateTime"> & { dateTime?: string; appointmentId?: string };

export const donationFormApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDonationFormByAppointmentId: builder.query<DonationFormData[], string>({
      query: (appointmentId) => `/donation-forms/appointment/${appointmentId}`,
      transformResponse: (res: ApiResponse<{ forms: DonationFormData[] }>) => res.data.forms,
      providesTags: ["DonationForm"],
    }),
    submitDonationForm: builder.mutation<DonationFormData, SubmitDonationFormInput>({
      query: (body) => ({ url: "/donations/form", method: "POST", body }),
      transformResponse: (res: ApiResponse<DonationFormData>) => res.data,
      invalidatesTags: ["DonationForm"],
    }),
  }),
});

export const { useGetDonationFormByAppointmentIdQuery, useSubmitDonationFormMutation } = donationFormApi;
